import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { MultitabComponent } from '@ibe.components/common/multitab/multitab.component';
// import { TAPMultitabComponent } from '@ibe.components/common/multitab/multitab.tap.component';
/* REPLICATED FILES */
import { INDRAMultitabComponent } from '@ibe.components/common/multitab/multitab.indra.component';
import { IBEAdminModule } from '@ibe.components/shared/ibe-admin.module';
import { DirectivesModule } from 'src/app/directives/directives.module';

@NgModule({
	imports: [ 
		CommonModule, 
		SVGModule, 
		IBEAdminModule ,
		DirectivesModule
		],
		
	declarations: [ 
		MultitabComponent, 
		INDRAMultitabComponent
		],
		
	exports: [ 
		INDRAMultitabComponent, 
		IBEAdminModule,
		DirectivesModule
	]
})
export class MultitabModule { }
